export enum ProductCategory {
    GRAIN = "grain",
    NUT = "nut",
    BERRY = "berry",
    VEGETABLE = "vegetable",
    FRUIT = "fruit",
    MEAT = "meat",
    FISH = "fish",
    POULTRY = "poultry",
    DAIRY = "dairy",
    LEGUMES = "legumes",
    SALAD_GREEN = "salad-green",
    EGG = "egg",
    CHEESE = "cheese",
    PASTA = "pasta",
    OIL = "oil",
    SPICES = "spices",
    SAUCE = "sauce",
    VINEGAR = "vinegar",
    HONEY = "honey",
    SYRUP = "syrup",
    OIL_SEEDS = "oil-seeds",
    MUSHROOM = "mushroom",
    BROTH = "broth",
    WATER = "water",
}

/** Culinary/physical form pool; includes `liquid` (not a ProductCategory). */
export enum FormGroup {
    GRAIN = "grain",
    NUT = "nut",
    BERRY = "berry",
    VEGETABLE = "vegetable",
    FRUIT = "fruit",
    MEAT = "meat",
    FISH = "fish",
    POULTRY = "poultry",
    DAIRY = "dairy",
    LEGUMES = "legumes",
    SALAD_GREEN = "salad-green",
    EGG = "egg",
    CHEESE = "cheese",
    PASTA = "pasta",
    OIL = "oil",
    SPICES = "spices",
    SAUCE = "sauce",
    VINEGAR = "vinegar",
    HONEY = "honey",
    SYRUP = "syrup",
    OIL_SEEDS = "oil-seeds",
    MUSHROOM = "mushroom",
    BROTH = "broth",
    WATER = "water",
    LIQUID = "liquid",
    ANY = "any",
}
